import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import "../../styles/CamerFed.css";
import { FaMinus, FaPauseCircle, FaPlus, FaRegFolder } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { BsGrid3X2, BsThreeDotsVertical } from "react-icons/bs";
import {
  DeleteCameraGroupApi,
  fetchCameragrouplistingApi,
  fetchCameralistingApi,
} from "../../api/api";
import cameraimg from "../../assets/image 285.png";
import Dropdown from "react-bootstrap/Dropdown";
import { RiDeleteBinLine } from "react-icons/ri";
import {
  MdCheckBoxOutlineBlank,
  MdEdit,
  MdOutlineGridOn,
} from "react-icons/md";
import { LuGrid2X2 } from "react-icons/lu";
import { useDispatch } from "react-redux";
import { Modal } from "react-bootstrap";
import {
  IoClose,
  IoCloseOutline,
  IoSearch,
  IoSettingsSharp,
} from "react-icons/io5";
import { SetGroupData } from "../../store/reducer/livefeed";
import { FaCirclePlay } from "react-icons/fa6";
import { useCamera } from "../../context/CameraProvider";
import { useVisionContext } from "../../Components/ContextAPI/VisionContext";

import CameraPlaceholder from "../../assets/camera_placeholder.png";
import GettingStarted from "./DefaultUi";

const CameraGroupPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [grid, setGrid] = useState(4);
  const [showSidebar, setShowSidebar] = useState(true);
  const [activeFeeds, setActiveFeeds] = useState([]);
  const [cameraGroups, setCameraGroups] = useState([]);
  console.log("cameraGroups", cameraGroups);
  const [groupName, setGroupName] = useState("");
  const [groupImage, setGroupImage] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);
  const [show, setShow] = useState(false);
  const [camera, setCamera] = useState([]);
  const [contextMenu, setContextMenu] = useState(null);
  const [selectedCamera, setSelectedCamera] = useState(null);
  const [showGroupModal, setShowGroupModal] = useState(false);
  const [selectedGroupOption, setSelectedGroupOption] = useState("");
  const [newGroupName, setNewGroupName] = useState("");
  const [visibility, setVisibility] = useState("Private");
  const [createWall, setCreateWall] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [error, setError] = useState("");
  const [loadingGroups, setLoadingGroups] = useState(true);
  // const [cameras, setCameras] = useState([]);
  const { cameras, setCameras } = useCamera();
  const { videoWall, setVideoWall } = useVisionContext();
  const [mouseOver, setMouseOver] = useState("");
  const { user_id, organization_id } = useSelector(
    (state) => state?.authUser?.data?.data
  );

  const toggleWallButton = () => {
    setCreateWall(!createWall);
  };

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      setDebouncedSearch(searchTerm);
    }, 500); // Debounce by 500ms

    return () => clearTimeout(delayDebounce);
  }, [searchTerm]);

  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 12,
  });
  const [showAllCameras, setShowAllCameras] = useState(true);

  const [totalRows, setTotalRows] = useState(0);
  const [gridDisplay, setGridDisplay] = useState({
    icon: <LuGrid2X2 size={24} />,
    label: "2x2",
  });

  const fetchGroup = async () => {
    setLoadingGroups(true);
    try {
      const search = debouncedSearch;
      const data = await fetchCameragrouplistingApi(
        search,
        user_id,
        organization_id
      );
      console.log("data", data);
      if (data?.data?.status === true) {
        setCameraGroups(data?.data?.data);
      }
    } catch (error) {
      console.error("Error fetching camera groups", error);
    } finally {
      setLoadingGroups(false);
    }
  };

  const fetchCamera = async () => {
    setActiveFeeds([]);
    try {
      setShowAllCameras(true);
      const page = pagination.pageIndex + 1;
      const limit = pagination.pageSize;
      const data = await fetchCameralistingApi(
        page,
        limit,
        null,
        user_id,
        organization_id
      );
      if (data?.data?.status === true) {
        const cams = data?.data?.data?.data || [];
        setCamera(cams);
        console.log("[INFO] cams: ", cams);
        setActiveFeeds(cams); // show all cameras
        setGrid(getBestGrid(cams.length));
        setTotalRows(data?.data?.data?.total || 0);
      }
    } catch (error) {
      //console.log("error", error);
    }
  };

  useEffect(() => {
    fetchCamera();
    fetchGroup();
  }, [pagination, debouncedSearch]);

  // useEffect(() => {
  //   fetchCamera();
  //   fetchGroup();
  // }, []);

  useEffect(() => {
    if (camera.length > 0) {
      const cams = camera.map((cam) => ({
        id: cam._id,
        name: cam.camera_name,
        camera_url: cam.camera_url || cameraimg,
        thumbnail: cam?.thumbnail,
      }));
      setActiveFeeds(cams);
      setGrid(getBestGrid(cams.length));
    }
  }, [camera]);

  const getBestGrid = (count) => {
    if (count <= 1) return 1;
    if (count <= 4) return 4;
    if (count <= 6) return 6;
    if (count <= 9) return 9;
    return 12;
  };

  const getGridClass = () => {
    if (grid === 1) return "grid-1";
    if (grid === 4) return "grid-4";
    if (grid === 6) return "grid-6";
    if (grid === 9) return "grid-9";
    return "grid-12";
  };

  const handleClose = () => setShow(false);

  const handleGroupSubmit = (e) => {
    e.preventDefault();
    if (groupName.trim()) {
      const formData = new FormData();
      formData.append("groupName", groupName);
      if (groupImage) formData.append("groupImage", groupImage);

      dispatch(
        SetGroupData({
          groupName,
          groupImage,
        })
      );
      handleClose();
      navigate(`/create-camera-group`);
    }
  };

  const handleRightClick = (event, camera) => {
    event.preventDefault();
    setSelectedCamera(camera);
    setContextMenu({
      x: event.pageX,
      y: event.pageY,
    });
  };

  const handleDelete = async (id) => {
    try {
      const data = await DeleteCameraGroupApi(id, user_id, organization_id);

      if (data) {
        fetchCamera();
        fetchGroup();
      }
    } catch (error) {}
  };

  const tooglePlay = (e, cam) => {
    e.preventDefault();
    // if (cameras.includes(id)) setCameras((prev) => prev.filter((ele) => ele !== id));
    // else setCameras((prev) => [...prev, id]);

    if (videoWall.length >= 6) {
      setError("You can only play 6 cameras at a time");
      return;
    }

    if (videoWall.includes(cam))
      setVideoWall((prev) => prev.filter((ele) => ele !== cam));
    else setVideoWall((prev) => [...prev, cam]);
  };

  const handleCameraFeed = (id) => {
    // setCameras([id]);

    navigate(`/events-details?id=${id}`);
  };

  return (
    <>
      {loadingGroups ? (
        <div className="p-4 text-center">
          <div className="spinner-border text-primary" role="status" />
        </div>
      ) : !camera || camera.length === 0 ? (
        <GettingStarted />
      ) : (
        <div className="d-flex">
          {/* Grid Section */}
          <div className="leftSection">
            <div className="dashSubHead d-flex gap-4 align-items-center px-4 py-3">
              <div className="searchNameOrAddress">
                <button className="serchBtn">
                  <IoSearch size={22} />
                </button>
                <input
                  placeholder="Search name"
                  className="form-control"
                  type="text"
                  name="searchTerm"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
              {/* <div className="searchNameOrAddress">
              <button className="serchBtn">
                <MdOutlineLocationOn size={22} />
              </button>
              <select className="form-select">
                <option value="">All Location</option>
                <option value="">Location 1</option>
                <option value="">Location 2</option>
                <option value="">Location 3</option>
                <option value="">Location 4</option>
              </select>
            </div>
            <button className="videoWallBtn ms-auto">Video Wall</button> */}
            </div>

            <div className="p-4">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h4 className="m-0">Recently Viewed</h4>

                <div className="selectCameraGrid align-items-center gap-3">
                  <button className="selectBtn" onClick={toggleWallButton}>
                    Select
                  </button>
                  <div className="singleBox m-0">
                    <Dropdown>
                      <Dropdown.Toggle id="dropdown-basic">
                        {gridDisplay.icon}
                        {/* {gridDisplay.label} */}
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        <Dropdown.Item
                          onClick={() => {
                            setGrid(1);
                            setGridDisplay({
                              icon: <MdCheckBoxOutlineBlank size={24} />,
                              label: "1x1",
                            });
                          }}
                        >
                          <MdCheckBoxOutlineBlank size={24} /> 1x1
                        </Dropdown.Item>
                        <Dropdown.Item
                          onClick={() => {
                            setGrid(4);
                            setGridDisplay({
                              icon: <LuGrid2X2 size={24} />,
                              label: "2x2",
                            });
                          }}
                        >
                          <LuGrid2X2 size={24} /> 2x2
                        </Dropdown.Item>
                        <Dropdown.Item
                          onClick={() => {
                            setGrid(6);
                            setGridDisplay({
                              icon: <BsGrid3X2 size={24} />,
                              label: "2x3",
                            });
                          }}
                        >
                          <BsGrid3X2 size={24} /> 2x3
                        </Dropdown.Item>
                        <Dropdown.Item
                          onClick={() => {
                            setGrid(9);
                            setGridDisplay({
                              icon: <MdOutlineGridOn size={24} />,
                              label: "3x3",
                            });
                          }}
                        >
                          <MdOutlineGridOn size={24} /> 3x3
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>

                    {/* <button onClick={() => setGrid(1)}><MdCheckBoxOutlineBlank /> 1x1</button>
                  <button onClick={() => setGrid(4)}><LuGrid2X2 /> 2x2</button>
                  <button onClick={() => setGrid(6)}><BsGrid3X2 /> 2x3</button>
                  <button onClick={() => setGrid(9)}><MdOutlineGridOn /> 3x3</button> */}
                    {/* <button className="btn" onClick={() => {setShow(true); }}><FiCamera size={23} /></button> */}
                  </div>
                </div>
              </div>

              {createWall ? (
                <>
                  <div className="crtCamerasGroup">
                    <button
                      disabled={!videoWall.length}
                      className="playBtn"
                      onClick={() => navigate("/video-wall")}
                    >
                      Play
                    </button>
                    <button disabled className="addToGroup">
                      Add to Group
                    </button>
                    <p className="m-0">{videoWall.length} cameras select</p>
                  </div>
                  <div className="text-danger">{error}</div>
                </>
              ) : (
                <></>
              )}

              <div className={`camera-grid ${getGridClass()}`}>
                {activeFeeds?.length > 0 ? (
                  (grid === 1 ? activeFeeds.slice(0, 1) : activeFeeds).map(
                    (cam) => (
                      <div
                        key={cam.id}
                        className={`camera-tile ${
                          createWall ? "creatWallGroup" : ""
                        }`}
                        onMouseOver={() => setMouseOver(cam?.id)}
                        onMouseLeave={() => setMouseOver("")}
                      >
                        <img
                          src={
                            "https://visionemptrack.greymatterz.com//attendance_photos/camera_thumbnail/" +
                            cam?.id +
                            ".png"
                          }
                          // src={
                          //   mouseOver === cam?.id
                          //     ? `https://visionemptrack.greymatterz.com/stream2/stream2/${
                          //         cam.id
                          //       }?t=${Date.now()}`
                          //     : cam?.thumbnail
                          //     ? "https://visionemptrack.greymatterz.com/" +
                          //       cam?.thumbnail.replace("media", "attendance_photos")
                          //     : CameraPlaceholder
                          // }
                          onClick={() => handleCameraFeed(cam?.id)}
                          alt={cam.name}
                        />
                        <div className="camera-label">{cam.name}</div>
                        {createWall ? (
                          <>
                            <button
                              className="plusBtn"
                              onClick={(e) => tooglePlay(e, cam)}
                            >
                              {videoWall.includes(cam) ? (
                                <FaMinus />
                              ) : (
                                <FaPlus />
                              )}
                            </button>
                          </>
                        ) : (
                          <>
                            <button
                              className="actionBtn"
                              onContextMenu={(e) => handleRightClick(e, cam)}
                            >
                              Action <BsThreeDotsVertical />
                            </button>
                            <div className="cameraDetail">
                              <div className="cameraContent">
                                <h3>{cam.name}</h3>
                                <p>{cam.location}</p>
                                <p>B-27 Sector 67 Noida India</p>
                              </div>
                              {/* <button className="settingBtn" onClick={(e) => tooglePlay(e, cam.id)}>
                          {cameras.includes(cam.id) ? (
                            <FaPauseCircle size={24} />
                          ) : (
                            <FaCirclePlay size={24} />
                          )}
                        </button> */}
                              <button
                                className="settingBtn"
                                onClick={() =>
                                  navigate(`/camera-event/${cam.id}`)
                                }
                              >
                                <IoSettingsSharp size={24} />
                              </button>
                            </div>
                          </>
                        )}
                      </div>
                    )
                  )
                ) : (
                  <span>No camera group right now!!</span>
                )}
              </div>

              <div className="d-flex justify-content-between align-items-center mt-4">
                {/* Grid Controls */}

                {showAllCameras && activeFeeds?.length > 0 && (
                  <div className="d-flex justify-content-between align-items-center gap-2">
                    <button
                      className="btn btn-outline-primary"
                      disabled={pagination.pageIndex === 0}
                      onClick={() =>
                        setPagination((prev) => ({
                          ...prev,
                          pageIndex: prev.pageIndex - 1,
                        }))
                      }
                    >
                      Previous
                    </button>

                    <span>Page {pagination.pageIndex + 1}</span>

                    <button
                      className="btn btn-outline-primary"
                      disabled={
                        (pagination.pageIndex + 1) * pagination.pageSize >=
                        totalRows
                      }
                      onClick={() =>
                        setPagination((prev) => ({
                          ...prev,
                          pageIndex: prev.pageIndex + 1,
                        }))
                      }
                    >
                      Next
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Sidebar Accordion */}
          {showSidebar && (
            <div className="rightSection bg-white border-start cameraGroupRightBox">
              <div className="titleFiltrer titleAdd p-4 border-bottom d-flex justify-content-between align-items-center position-sticky top-0 bg-white z-3">
                <h3>Camera Groups</h3>
                <button
                  className="addBtn"
                  onClick={() => {
                    setShow(true);
                  }}
                >
                  + Add
                </button>
              </div>

              <ul className="crtCameraGroup">
                {cameraGroups && cameraGroups.length > 0 ? (
                  cameraGroups.map((group, index) => (
                    <li
                      key={group._id || index}
                      onClick={() => {
                        const cams = group.camera_details.map((c) => ({
                          id: c._id,
                          name: c.camera_name,
                          camera_url: c.camera_url || cameraimg,
                          thumbnail: c?.thumbnail,
                        }));
                        setActiveFeeds(cams);
                        setGrid(getBestGrid(cams.length));
                        setShowAllCameras(false);
                      }}
                    >
                      <FaRegFolder size={22} />{" "}
                      {group.camera_grp_name || "Unnamed Group"}
                      <span>
                        {String(`(${group.camera_details.length})`).padStart(
                          2,
                          "0"
                        )}
                      </span>
                      <div className="editDeleteDropdown">
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            handleDelete(group?._id);
                          }}
                        >
                          <RiDeleteBinLine size={22} /> Delete
                        </button>
                      </div>
                    </li>
                  ))
                ) : (
                  <span>No camera group created</span>
                )}
              </ul>

              {/* <Accordion className="cstAccordion" defaultActiveKey="0">
              {cameraGroups.map((group, index) => (
                <Accordion.Item eventKey={index.toString()} key={group._id}>
                  <Accordion.Header
                    onClick={() => {
                      const cams = group.camera_details.map((c) => ({
                        id: c._id,
                        name: c.camera_name,
                        camera_url: c.camera_url || cameraimg,
                      }));
                      setActiveFeeds(cams);
                      setGrid(getBestGrid(cams.length));
                      setShowAllCameras(false);
                    }}
                  >
                    
                    <div className="cameraList align-items-center">
                      <img
                        src={`${process.env.REACT_APP_BACKEND_URL}/${group.thumbnail_image}`}
                        className="img-fluid"
                      />
                      <div style={{ flex: "1" }}>
                        <h3 className="mb-2">
                          {group.camera_grp_name || "Unnamed Group"}
                        </h3>
                        <p>
                          {String(group.camera_details.length).padStart(2, "0")}{" "}
                          Cameras
                        </p>
                        <button
                          className="removeBtn"
                          onClick={() => handleDelete(group?._id)}
                        >
                          Remove Group <RiDeleteBin5Line />
                        </button>
                      </div>
                    </div>
                  </Accordion.Header>
                  <Accordion.Body>
                   

                    {group.camera_details.map((cam) => (
                      <div key={cam._id} className="cameraList">
                        <img src={cameraGroup} className="img-fluid" />
                        <div style={{ flex: "1" }}>
                          <h3 className="d-flex justify-content-between">
                            {cam.camera_name}
                            <Dropdown className="dropDownBtn">
                              <Dropdown.Toggle id="dropdown-basic">
                                <BsThreeDots />
                              </Dropdown.Toggle>
                              <Dropdown.Menu>
                                <Dropdown.Item href="#/action-1">
                                  <AiOutlineSetting size={24} /> Settings
                                </Dropdown.Item>
                                <Dropdown.Item href="#/action-2">
                                  <RiDeleteBin6Line size={22} /> Delete
                                </Dropdown.Item>
                              </Dropdown.Menu>
                            </Dropdown>
                          </h3>
                          <p>{cam.location}</p>
                        </div>
                      </div>
                    ))}
                  </Accordion.Body>
                </Accordion.Item>
              ))}
            </Accordion> */}
            </div>
          )}
        </div>
      )}
      <Modal
        show={show}
        onHide={handleClose}
        centered
        className="creatGroupModal"
      >
        <button onClick={handleClose} className="closeBtn">
          <IoCloseOutline size={26} />
        </button>
        <Modal.Body>
          <h3 className="mb-3">Camera Group</h3>
          <form onSubmit={handleGroupSubmit}>
            <label>Enter Group Name</label>
            <input
              className="form-control mt-1 mb-3"
              type="text"
              value={groupName}
              onChange={(e) => setGroupName(e.target.value)}
              placeholder="Camera Group"
              required
            />

            <label>Upload Group Image</label>
            <input
              type="file"
              accept="image/*"
              className="form-control mt-1 mb-3"
              onChange={(e) => {
                const file = e.target.files[0];
                if (file) {
                  const reader = new FileReader();
                  reader.onloadend = () => {
                    const base64Image = reader.result;
                    setPreviewImage(base64Image);
                    setGroupImage(base64Image);
                  };
                  reader.readAsDataURL(file);
                }
              }}
            />

            {previewImage && (
              <img
                src={previewImage}
                alt="Preview"
                style={{
                  width: "100%",
                  maxHeight: "150px",
                  objectFit: "cover",
                  marginBottom: "1rem",
                  borderRadius: "8px",
                }}
              />
            )}

            <div className="buttonGroup">
              <button onClick={handleClose} className="cancelBtn">
                Cancel
              </button>
              <button type="submit" className="nextBtn">
                Next
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>

      {contextMenu && (
        <div
          className="custom-context-menu"
          style={{
            position: "absolute",
            top: contextMenu.y,
            left: contextMenu.x,
            background: "#fff",
            border: "1px solid #ccc",
            // borderRadius: "6px",
            boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
            zIndex: 9999,
            width: 280,
            padding: 20,
          }}
          onMouseLeave={() => setContextMenu(null)}
        >
          <div
            className="menu-item mb-1"
            onClick={() => {
              setShowGroupModal(true);
              setContextMenu(null);
            }}
          >
            <FaPlus size={20} /> Add to Group...
          </div>
          <div
            className="menu-item"
            onClick={() => {
              // Handle "Edit" action
              //console.log("Edit Camera", selectedCamera);
              setContextMenu(null);
            }}
          >
            <MdEdit size={22} /> Edit...
          </div>

          <hr />

          <div className="mb-2">
            <strong>Motion AI Insights</strong>
          </div>
          <div>
            <input type="radio" name="motion" /> Motion Disabled
          </div>
          <div>
            <input type="radio" name="motion" defaultChecked /> Motion Search
          </div>
          <div>
            <input type="radio" name="motion" /> People Search
          </div>
          <div>
            <input type="radio" name="motion" /> Vehicle Search
          </div>

          <hr />

          <div>
            HD available since: <strong>Dec 1, 2021</strong>
          </div>
          <div>
            SD available since: <strong>Sep 11, 2021</strong>
          </div>
          <div>Thumbnail Updated: ...</div>
        </div>
      )}

      <Modal
        show={showGroupModal}
        onHide={() => setShowGroupModal(false)}
        centered
        className="addToGroupModal"
      >
        <Modal.Body>
          <div className="d-flex justify-content-between align-items-center pb-2 border-bottom">
            <h3>Add to Existing or New Group</h3>
            <button
              className="modalCloseBtn"
              onClick={() => setShowGroupModal(false)}
            >
              <IoClose size={24} />
            </button>
          </div>
          <div className="p-3">
            <h5 className="labelTitle mb-3">To Existing Groups</h5>
            <div className="formCheckBox">
              {[
                "Favorites",
                "Back Doors",
                "Driver Thrus",
                "Fridges / Freezers",
                "Offices",
                "Test",
              ].map((group) => (
                <div
                  className="d-flex align-items-center gap-2 mb-2"
                  key={group}
                >
                  <input
                    className="form-check-input formCheckInput m-0"
                    type="checkbox"
                    id={group}
                    checked={selectedGroupOption === group}
                    onChange={() => setSelectedGroupOption(group)}
                  />
                  <label className="form-check-label" htmlFor={group}>
                    {group}
                  </label>
                </div>
              ))}
            </div>
          </div>

          <div className="lineToSepret pb-4">
            <span>OR</span>
          </div>

          <div className="p-3">
            <input
              className="form-check-input formCheckInput"
              type="checkbox"
              id="newGroup"
              checked={selectedGroupOption === "new"}
              onChange={() => setSelectedGroupOption("new")}
            />
            <label className="form-check-label ms-2" htmlFor="newGroup">
              Add to a New Group
            </label>
            <input
              className="form-control mt-2"
              type="text"
              disabled={selectedGroupOption !== "new"}
              value={newGroupName}
              onChange={(e) => setNewGroupName(e.target.value)}
              placeholder="Add Group Name"
            />
          </div>

          <div className="px-3 py-2">
            <h5 className="labelTitle mb-2">Visibility</h5>
            <div className="d-flex gap-4 mt-2">
              <div className="d-flex align-items-center gap-2 me-3">
                <input
                  type="radio"
                  name="visibility"
                  value="Private"
                  checked={visibility === "Private"}
                  onChange={(e) => setVisibility(e.target.value)}
                  style={{ height: "18px", width: "18px" }}
                />{" "}
                Private
              </div>
              <div className="d-flex align-items-center gap-2">
                <input
                  type="radio"
                  name="visibility"
                  value="Shared"
                  checked={visibility === "Shared"}
                  onChange={(e) => setVisibility(e.target.value)}
                  style={{ height: "18px", width: "18px" }}
                />{" "}
                Shared
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="p-4 d-flex gap-3 align-items-center">
          <button
            className="btn py-2 transParent3"
            onClick={() => setShowGroupModal(false)}
          >
            Cancel
          </button>
          <button
            className="btn py-2 mainBlue3"
            onClick={() => {
              console.log({
                selectedGroup:
                  selectedGroupOption === "new"
                    ? newGroupName
                    : selectedGroupOption,
                visibility,
              });
              setShowGroupModal(false);
            }}
          >
            Save
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default CameraGroupPage;
